<cm-sidebar-layout>
    <cm-item-filters cm-filters>
        <cm-tag-search-filter placeholder="Name, description, ID ..."></cm-tag-search-filter>
        <cm-checkboxes-filter label="State" name="state" [options]="Labels.JobState"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Discarded" name="discarded" [options]="Labels.Discarded"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Job Type" name="jobType" [options]="Labels.JobType"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Task Type" name="jobTaskType" [options]="Labels.JobTaskType"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Queue Group" name="jobQueueGroup" [options]="Labels.JobQueueGroup"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Organizations" name="organizationId" [options]="organizations.$filterOptions()"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Users" name="userId" [options]="$userLabels()"></cm-checkboxes-filter>
    </cm-item-filters>
    <cm-job-system-health></cm-job-system-health>
    <cm-jobs-table></cm-jobs-table>
</cm-sidebar-layout>

<router-outlet></router-outlet>
